require('./bootstrap');
// import './bootstrap';

// Bugsnag

import Bugsnag from '@bugsnag/js';

if (process.env.NODE_ENV === 'production') {
    Bugsnag.start({
        apiKey: '7bc05ed3207d8a790419211ec75fc064',
        releaseStage: process.env.NODE_ENV
    });
}

// Bootbox

import bootbox from 'bootbox';
window.bootbox = bootbox;

// Bootstrap Date Range Picker

import daterangepicker from 'bootstrap-daterangepicker';
window.daterangepicker = daterangepicker;

// Bootstrap Table

window.bootstrap = {
    Tooltip: {
        VERSION: "5"
    }
}

import('bootstrap-table');

// Chart.js

// import chart from 'chart.js/auto';
// window.Chart = chart;

// Chosen
import('chosen-js');

// Flatpickr

// import flatpickr from 'flatpickr';
// window.flatpickr = flatpickr;
window.flatpickr = require('flatpickr');

// jQuery - Date Time Picker
import('jquery-datetimepicker');

// jQuery UI - autocomplete
import 'jquery-ui/ui/widgets/autocomplete.js';

// jQuery UI - sortable
import 'jquery-ui/ui/widgets/sortable.js';

// Moment.js

import moment from 'moment';
window.moment = moment;

// NProgress

import nprogress from 'nprogress';
window.NProgress = nprogress;

// Sprintf-js
window.sprintf = require('sprintf-js').sprintf;
window.vsprintf = require('sprintf-js').vsprintf;

// SweetAlert2

import sweetalert2 from 'sweetalert2';
window.Swal = sweetalert2;

// App

require('./app/actions.js');
require('./app/chosen.js');
require('./app/colorCellStyle.js');
require('./app/confirm.js');
require('./app/datepicker.js');
require('./app/daterangepicker.js');
require('./app/font_awesome.js');
require('./app/i18n.js');
require('./app/nbrogress.js');
require('./app/ready.js');
require('./app/sidebar.js');
require('./app/tables.js');
require('./app/tabs.js');
require('./app/tooltip.js');
require('./app/validation.js');

// Formatters

require('./app/formatters/boolean.js');
require('./app/formatters/color.js');
require('./app/formatters/delete.js');
require('./app/formatters/edit.js');
require('./app/formatters/healthCheckDetail.js');
require('./app/formatters/healthCheckStatus.js');
require('./app/formatters/rowBackgroundColor.js');
require('./app/formatters/rowStyle.js');
require('./app/formatters/show.js');

// Functions

require('./app/functions/number_format.js');
require('./app/functions/number_format_to_decimal.js');
